import { authenticatedRequest } from "../../../shared/api";
import { RegistrationCounts } from "../../../shared/types";

export const getUsersRegisteredByReferral = async (code: string) => {
  return await authenticatedRequest<RegistrationCounts>({
    method: "get",
    path: `/usersRegisteredByReferral/${code}`,
  });
};
